import {
  CLEAR_PAGINATION_STATE,
  GET_PAGINATION_STATE,
  SET_SMSMESSAGES_PAGINATION_STATE,
  SET_GROUPS_PAGINATION_STATE,
  SET_GROUPCONTACTS_PAGINATION_STATE,
  SET_SENDHISTORY_PAGINATION_STATE,
  SET_SHEDULEDSEND_PAGINATION_STATE,
  SET_RECIPIENTS_PAGINATION_STATE,
  SET_OPTINS_PAGINATION_STATE,
  SET_PAINDING_PAGINATION_STATE,
  SET_OPTOUT_PAGINATION_STATE,
  SET_INVALID_PAGINATION_STATE,
  SET_SUCCSEND_MESSAGESTATISTICS_STATE,
  SET_TEXTRESPONSE_PAGINATION_STATE,
  SET_PAYMENT_SHORTLINK_PAGINATION_STATE,
  SET_ACTIVEEVENTS_PAGINATION_STATE,
  SET_ENDEDEVENTS_PAGINATION_STATE,
} from "./PaginationRowType";

const getPaginationState = () => {
  return {
    type: GET_PAGINATION_STATE,
  };
};

const setSmsMessagesPaginationState = (data) => {
  return {
    type: SET_SMSMESSAGES_PAGINATION_STATE,
    payload: data,
  };
};
const setGroupsPaginationState = (data) => {
  return {
    type: SET_GROUPS_PAGINATION_STATE,
    payload: data,
  };
};
const setGroupContactsPaginationState = (data) => {
  return {
    type: SET_GROUPCONTACTS_PAGINATION_STATE,
    payload: data,
  };
};
const setOptinsPaginationState = (data) => {
  return {
    type: SET_OPTINS_PAGINATION_STATE,
    payload: data,
  };
};
const setPaindingPaginationState = (data) => {
  return {
    type: SET_PAINDING_PAGINATION_STATE,
    payload: data,
  };
};
const setOptoutPaginationState = (data) => {
  return {
    type: SET_OPTOUT_PAGINATION_STATE,
    payload: data,
  };
};
const setInvalidPaginationState = (data) => {
  return {
    type: SET_INVALID_PAGINATION_STATE,
    payload: data,
  };
};
const setSendHistoryPaginationState = (data) => {
  return {
    type: SET_SENDHISTORY_PAGINATION_STATE,
    payload: data,
  };
};
const setSheduledSendPaginationState = (data) => {
  return {
    type: SET_SHEDULEDSEND_PAGINATION_STATE,
    payload: data,
  };
};
const setRecipientsPaginationState = (data) => {
  return {
    type: SET_RECIPIENTS_PAGINATION_STATE,
    payload: data,
  };
};
const succSendMsgStatsPaginationState = (data) => {
  return {
    type: SET_SUCCSEND_MESSAGESTATISTICS_STATE,
    payload: data,
  };
};
const textResponseMsgStatsPaginationState = (data) => {
  return {
    type: SET_TEXTRESPONSE_PAGINATION_STATE,
    payload: data,
  };
};
const paymentShortLinkPaginationState = (data) => {
  return {
    type: SET_PAYMENT_SHORTLINK_PAGINATION_STATE,
    payload: data,
  };
};
const setActiveEventsPaginationState = (data) => {
  return {
    type: SET_ACTIVEEVENTS_PAGINATION_STATE,
    payload: data,
  };
};
const setEndedEventsPaginationState = (data) => {
  return {
    type: SET_ENDEDEVENTS_PAGINATION_STATE,
    payload: data,
  };
};
const clearPaginationState = (data) => {
  return {
    type: CLEAR_PAGINATION_STATE,
    payload: data,
  };
};
const PaginationRowAction = {
  getPaginationState,
  clearPaginationState,
  setSmsMessagesPaginationState,
  setGroupsPaginationState,
  setGroupContactsPaginationState,
  setOptinsPaginationState,
  setPaindingPaginationState,
  setOptoutPaginationState,
  setInvalidPaginationState,
  setSendHistoryPaginationState,
  setSheduledSendPaginationState,
  setRecipientsPaginationState,
  succSendMsgStatsPaginationState,
  textResponseMsgStatsPaginationState,
  paymentShortLinkPaginationState,
  setActiveEventsPaginationState,
  setEndedEventsPaginationState,
};
export default PaginationRowAction;
